import styled, { css } from "styled-components";

import BaseButton from "shared/components/inputs/button/BaseButton";
import { FEEDBACK_TYPES } from "shared/config/feedbackTypes";
import { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";
import { TertiaryButtonStyle } from "shared/components/inputs/button/Button.styles";
import {
    TextInputStyles,
    TextInputStylesDisabled,
    TextInputStylesError,
    TextInputStylesSuccess,
    TextInputStylesWarning,
} from "shared/components/inputs/input/TextInput.styles";
import VStack from "shared/components/layout/stack/VStack";

export const StyledRangeDateFieldWrapper = styled.div`
    ${TEXT_VARIANT_STYLES.Body_1_1}

    ${TextInputStyles}

     ${(props) =>
        props.isSmallSize
            ? css`
                  ${TextInputStyles} {
                      min-height: 36px;
                      padding: 8px 8px 8px 12px;
                  }
                  ${TEXT_VARIANT_STYLES.Body_2_1};
              `
            : css`
                  ${TextInputStyles} {
                      padding: 12px 8px 12px 12px;
                  }
              `}

    ${(props) =>
        props.feedbackType === FEEDBACK_TYPES.Success &&
        css`
            ${TextInputStylesSuccess}
        `}
     ${(props) =>
        props.feedbackType === FEEDBACK_TYPES.Warning
            ? css`
                  ${TextInputStylesWarning}
              `
            : props.feedbackType === FEEDBACK_TYPES.Error &&
            css`
                  ${TextInputStylesError}
              `}

    ${(props) =>
        props.disabled &&
        css`
            ${TextInputStylesDisabled}
        `}

    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: default;
`;

export const StyledBaseButton = styled(BaseButton)`
    padding: 2px;

    ${TertiaryButtonStyle}
`;

export const RangeCalendarWrapper = styled(VStack)`
    cursor: not-allowed;
`;
